import 'systemjs/dist/s';

declare global {
  interface Window {
    System: Record<string, any>;
  }
}

export const systemJSPrototype = window.System.constructor.prototype;
